import { render } from "./VGradualText.vue?vue&type=template&id=13359d14"
import script from "./VGradualText.vue?vue&type=script&lang=js"
export * from "./VGradualText.vue?vue&type=script&lang=js"

import "./VGradualText.vue?vue&type=style&index=0&id=13359d14&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__